/*
 * mobileReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import { CHANGE_USERNAME, MOBILE_NUMBER } from './constants';

// The initial state of the App
export const initialState = {
  username: '',
  mobileNumber:''
};

/* eslint-disable default-case, no-param-reassign */
const mobileReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case CHANGE_USERNAME:
        // Delete prefixed '@' from the github username
        draft.username = action.username.replace(/@/gi, '');
        break;
      case MOBILE_NUMBER:
        draft.mobileNumber= action.number;
        break;
    }
  });

export default mobileReducer;
